<template>
    <rkm-modal
        :loading="loading"
        large
        ref="Modal"
        persistent
        title="Grupos"
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Unidade"
                    :value="centroCusto.unidadeNomeFantasia"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Local de atendimento"
                    :value="centroCusto.localAtendimentoNome"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    label="Setor"
                    :value="centroCusto.setorNome"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-area title="Grupos">
            <rkm-table
                :fields="fields"
                :items="centroCusto.grupos"
            >
                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="$refs.ModalMaterial.open(item)"
                        color="primary"
                        :disabled="item.materiais.length == 0"
                        small
                        :title="item.materiais.length == 0 ? 'Este grupo não possui materiais com permissão de controle de estoque' : 'Configurar estoque'"
                    >
                        <rkm-icon icon="cog" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>

        <ModalMaterial ref="ModalMaterial" />
    </rkm-modal>
</template>

<script>
// Components
import ModalMaterial from './components/material/Modal'

// Vuex.
import { mapGetters } from 'vuex'

// Others.
import { object } from '@/mixins'

export default {
    components: { ModalMaterial },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
    },
    data: () => ({
        centroCusto: {},
    }),
    methods: {
        open(centroCusto) {

            this.centroCusto = centroCusto

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
    },
    mixins: [object],
}
</script>